__turbopack_context__.v({
  "icon": "Icon-module-scss-module__SpM10q__icon",
});
